import { FC, useContext, useState } from "react"
import { EnterpriseComplianceFiltersContext } from "../contexts/EcdFiltersContext"
import { QESButton, QESTextInput } from "@app/shared/qes-standards";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { toast } from "react-toastify";

const EcdSaveFiltersFlyout: FC = () => {
    const flyoutContext = useContext(FlyoutContext);
    const filtersContext = useContext(EnterpriseComplianceFiltersContext);
    const [name, setName] = useState("");

    const handleSave = () => {
        if (isNameValid()) {
            filtersContext.saveCustomFilterSet(name);
            toast(<span>Filter set &quot;{name}&quot; has been saved</span>,
                {
                    containerId: "z-index-9999",
                    onOpen: () => {
                        flyoutContext.handleCloseFlyout();
                    },
                    type: "success",
                },
            );
        }
    }

    const isNameValid = () => {
        return name !== "" && name !== "default";
    }

    return (
        <>
            <QESTextInput
                label="Filter Set Name"
                testId="ecd-save-filters-flyout__filter-set-name"
                onChange={(e: React.ChangeEvent) => setName((e.target as HTMLInputElement).value)}
                isValid={isNameValid()}
                required={true}
                list="filters-list"
            />
            <datalist id="filters-list">
                {filtersContext.filterSetNames.map((f) => (
                    <option value={f} key={f}>{f}</option>
                ))}
            </datalist>
            <FlyoutFooter
                submitButton={
                    <QESButton
                        qesType="primary"
                        qesTestId="ecd-save-filters-flyout__save"
                        onClick={handleSave}
                        disabled={!isNameValid()}
                    >
                        Save
                    </QESButton>
                }
            />
        </>
    );
}

export default EcdSaveFiltersFlyout;
